module.exports = ".ui-menu-list\r\n{\r\n    border:1px solid #337ab7;color:#337ab7;\r\n}\r\n\r\n.ui-menuitem .ui-menuitem-link  {\r\n    color:#337ab7 !important;\r\n    text-decoration: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/lookup-management/reportcategory/reportcategory.component.css
// module id = ./src/app/admin/lookup-management/reportcategory/reportcategory.component.css
// module chunks = main